<template>
    <div>
        <div class="module-hero">
            <img :src="'../../static/'+ currentLocale +'/hero.jpg'" alt="" class="img-hero" >
        </div>
        <Page v-bind:pagedata="page" v-if="page != null" v-show="!pageLoading"></Page>
        <div class="container loader" v-show="pageLoading">
            <h2>{{ $t('general.ladataan', currentLocale) }}...</h2>
        </div>
    </div>
</template>
<script>
  import HeroStart from '@/views/components/HeroStart'
  import Page from './Page.vue'
  import secretStore from '../../utils/localstorage'

  export default {
    data: function () {
      return {
        locales: ['es','gl','ca','eu'],
        pageLoading: false,
        page: null
      }
    },
    components: {
      HeroStart,
      Page
    },
    props: {
      pid: null,
      pids: [],
      colorclass: '',
      herosrc: ''
    },
    watch: {
      'pid': function (pid) {
        if (pid != null) {
          this.fetchPage()
        }
      }
    },
    created: function () {
      this.fetchPage()
    },
    methods: {
      fetchPage: function () {
        this.pageLoading = true
        var pageId = this.pids[this.currentPidIndex]
        console.debug(pageId)
        this.axios.get('pages/' + pageId + '?orderby=menu' ).then((response) => {
          this.page = response.data
          this.pageLoading = false
        })
      },
    },
    computed: {
        currentLocale() {
          return this.$route.params.locale
        },
        currentPidIndex() {
          return this.locales.indexOf( this.currentLocale );  
        }
    },
  }
</script>

<style scoped lang="scss">
    .loader {
        padding: 4em;
        text-align: center;

        h2 {
            font-size: 24px;
            color: #059DF3;
            font-weight: bold;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/components/ContentUnitSingle.vue